<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Donation Amount">
                    <div>
                        <AmountSelector/>                    
                        <ErrorLabel field="amount" />
                    </div>
                </FormSection>
                <FormSection title="Designation">
                  <FormRow class="designation" inline>
                    <FormSelect field="custom.designation">
                      <option selected="selected" value="General Donation">
                        General Donation
                      </option>
                      <option value="Help Spread the Word about this Mitzvah">Help Spread the Word about this Mitzvah</option>
                      <option value="Aveidah.com Website Developent">Aveidah.com Website Developent</option>
                      <option value="Shipping Costs">Help Others with Shipping Costs to Fulfill this Mitzvah</option>
                    </FormSelect>
                  </FormRow>
                </FormSection>
                <FormSection v-if="form.amount">
                  <TransactionFee />
                </FormSection>    
                <FormSection title="Personal Information">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>                    
                    <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                    </FormRow>                    
                    <DonorAddress />
                </FormSection>
                <FormSection title="Payment Information" last>
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false"/>
                    </FormRow>
                </FormSection>
                <PaymentButton btnText="Donate Now"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  props: {
    subCampaign: String,
  },
  setup() {
    const { form, submit } = usePaymentForm()

    return {
      form,
      submit,
    }
  },
})
</script>
<style scoped lang="scss">
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
</style>

